"use strict";
'use es6'; // TODO move to ecosystem-marketplace-core

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = _interopRequireDefault(require("immutable"));

var _formatters = require("ecosystem-marketplace-core/utils/formatters");

var ConnectionType = _interopRequireWildcard(require("../constants/ConnectionType"));

var defaults = {
  connectionType: ConnectionType.STANDARD,
  hubInstalls: 0,
  hubspotPolicy: false,
  nativeId: ''
};

var ThinVersion = /*#__PURE__*/function (_Immutable$Record) {
  (0, _inherits2.default)(ThinVersion, _Immutable$Record);

  function ThinVersion() {
    var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, ThinVersion);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ThinVersion).call(this, (0, _formatters.cleanObject)(json)));
  }

  return ThinVersion;
}(_immutable.default.Record(defaults));

var _default = ThinVersion;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/records/ThinVersion.js
// module id = 775
// module chunks = 209 210 211 212